import { LOGIN_VALIDATION, VALIDATION_MSGS } from "../constants/login.constants";
import { CONTACT_US_VALIDATION, CONTACT_US_VALIDATION_MSGS } from "../constants/contact-us.constants";

export const validateName = (value) => {
  const errors = [];
  if (value === null || value === "" || value === undefined) {
    errors.push(VALIDATION_MSGS.REQUIRED);
  }
  if(!LOGIN_VALIDATION.NAME.test(value)){
      errors.push(VALIDATION_MSGS.INVALID_NAME);
  }
  return errors;
};

export const validateContactNumber = (phoneNumber) => {
    const errors = [];
    if (!phoneNumber || phoneNumber.length == 0) {
      errors.push(VALIDATION_MSGS.REQUIRED);
    }
    else if (!LOGIN_VALIDATION.CONTACT_NUMBER.test(phoneNumber)) {
      errors.push(VALIDATION_MSGS.INVALID_CONTACT_NUMBER);
    }
    return errors;
  };
  
  export const validateEmail = (email) => {
    const errors = [];
    if (!email || email.length == 0) {
      errors.push(VALIDATION_MSGS.REQUIRED);
    }
    else if (!LOGIN_VALIDATION.EMAIL.test(email)) {
      errors.push(VALIDATION_MSGS.INVALID_EMAIL);
    }
    
    return errors;
  };


  export const validatePassword = (value) => {
    const errors = [];
    if (value === null || value === "" || value === undefined) {
      errors.push(VALIDATION_MSGS.REQUIRED);
    }
    else if(!LOGIN_VALIDATION.PASSWORD.test(value)){
        errors.push(VALIDATION_MSGS.INVALID_PASSWORD);
    }
    return errors;
  }


  export const validateConfirmPassword = (confirmPassword, password) => {
    const errors = [];
    if (confirmPassword === null || confirmPassword === "" || confirmPassword === undefined) {
      errors.push(VALIDATION_MSGS.REQUIRED);
    }
    else if(confirmPassword !== password) {
        errors.push(VALIDATION_MSGS.INVALID_CONFIRM_PASSWORD)
    }
    return errors;
  }

  export const validateField = (value) => {
    const errors = [];
    if (value === null || value === "" || value === undefined) {
      errors.push(VALIDATION_MSGS.REQUIRED);
    }
    return errors;
  }

  export const validateOTP = (value) => {
    const errors = [];
    if (value === null || value === "" || value === undefined) {
      errors.push(VALIDATION_MSGS.REQUIRED);
    }
    else if(!LOGIN_VALIDATION.OTP.test(value)){
        errors.push(VALIDATION_MSGS.INVALID_OTP);
    }
    return errors;
  }

  export const validateEmailBody = (value) => {
    const errors = [];
    if (value === null || value === "" || value === undefined) {
      errors.push(VALIDATION_MSGS.REQUIRED);
    }
    else if(!CONTACT_US_VALIDATION.EMAIL_MESSAGE.test(value)){
        errors.push(CONTACT_US_VALIDATION_MSGS.INVALID_EMAIL_BODY);
    }
    return errors;
  }
